import React, { Component, Fragment } from 'react';
import Breadcrumb from '../common/breadcrumb';
import Tabset from './tabset-editar-documento';

export class EditContent extends Component {
  render() {
    return (
      <Fragment>
        <Breadcrumb title="Editar Documento" parent="Documentos" />
        <div className="container-fluid">
          <div 
            className="card"
            style={{ 
              minHeight: '75vh'
            }}
          >
            <div className="card-header">
              <h5>Editar Documento</h5>
            </div>
            <div className="card-body">
              <Tabset />
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default EditContent;
